import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  title: {
    id: 'components.PatientsTable.title',
    defaultMessage: '{length, plural, one {# patient} other {# patients}}',
  },
  titleFirstResults: {
    id: 'components.PatientsTable.titleFirstResults',
    defaultMessage:
      '{length, plural, one {# patient. Here are the first {maxRows} results:} other {# patients. Here are the first {maxRows} results:}}',
  },
  modalTitle: {
    id: 'components.PatientsTable.modalTitle',
    defaultMessage: "It's on its way!",
  },
  modalDescription: {
    id: 'components.PatientsTable.modalDescription',
    defaultMessage: "We're prepping this list for you and will send it to you at {userEmail} as soon as its ready.",
  },
  modalThankYouMessage: {
    id: 'components.PatientsTable.modalDescription',
    defaultMessage: 'Thanks for your patience.',
  },
  modalClose: {
    id: 'components.PatientsTable.modalClose',
    defaultMessage: 'Close',
  },
  sendBroadcastReport: {
    id: 'components.PatientsTable.sendBroadcastReport',
    defaultMessage: 'Send recipient list to email',
  },
  noContactEmail: {
    id: 'components.PatientsTable.noContactEmail',
    defaultMessage:
      'There is no email address associated with your account. Please contact the Luma Support team to add one.',
  },
});
